import { ReactNode } from 'react';

import { ModuleContext } from '../modules/shared/moduleContext/ModuleContext.js';
import { useNewModule } from './hooks/useNewModule.tsx';

export const ModuleContextProvider = ({
  children,
  expectOrder,
}: {
  children: ReactNode;
  expectOrder: boolean;
}) => (
  <ModuleContext.Provider value={useNewModule(expectOrder, true)}>
    {children}
  </ModuleContext.Provider>
);
